import * as React from 'react';

export const FormGroupSpacer: React.FC = ({ children }) => (
  <div style={{ marginTop: '10px' }}>
    {children}
  </div>
);